import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Materials',
    path: '/materials'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className="sticky top-0 z-50 w-full bg-sandev-bg/90 backdrop-blur-md border-b border-sandev-border" data-id="element-61">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="flex justify-between items-center h-20" data-id="element-63">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group" data-id="element-64">
            <div className="w-10 h-10 rounded overflow-hidden bg-sandev-card border border-sandev-border group-hover:border-sandev-accent transition-colors duration-300 flex items-center justify-center" data-id="element-65">
              <img src="https://cdn.magicpatterns.com/uploads/rmRVKZFYhXZrX1RFCfWxiS/SanDev_Logo_v5.png" alt="SanDev Logo" className="w-full h-full object-contain" data-id="element-66" />
            </div>
            <span className="font-bold text-xl tracking-tight text-sandev-text" data-id="element-67">
              SanDev<span className="text-sandev-accent" data-id="element-68">.</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-69">
            <div className="flex gap-6" data-id="element-70">
              {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors duration-200 hover:text-sandev-accent ${isActive(link.path) ? 'text-sandev-accent' : 'text-sandev-muted'}`} data-id="element-71">
                  {link.name}
                </Link>)}
            </div>
            <Link to="/contact" className="bg-sandev-accent hover:bg-sandev-accentHover text-white px-5 py-2.5 rounded-md text-sm font-semibold transition-all duration-200 shadow-[0_0_15px_rgba(0,180,216,0.3)] hover:shadow-[0_0_25px_rgba(0,180,216,0.5)]" data-id="element-72">
              Get a Quote
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-73">
            <button onClick={() => setIsOpen(!isOpen)} className="text-sandev-muted hover:text-sandev-text focus:outline-none" data-id="element-74">
              {isOpen ? <X size={24} data-id="element-75" /> : <Menu size={24} data-id="element-76" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-77">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-sandev-card border-b border-sandev-border overflow-hidden" data-id="element-78">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-79">
              {navLinks.map(link => <Link key={link.name} to={link.path} onClick={() => setIsOpen(false)} className={`block px-3 py-3 rounded-md text-base font-medium ${isActive(link.path) ? 'bg-sandev-bg text-sandev-accent' : 'text-sandev-muted hover:bg-sandev-bg hover:text-sandev-text'}`} data-id="element-80">
                  {link.name}
                </Link>)}
              <div className="pt-4 px-3" data-id="element-81">
                <Link to="/contact" onClick={() => setIsOpen(false)} className="block w-full bg-sandev-accent hover:bg-sandev-accentHover text-white px-5 py-3 rounded-md text-base font-semibold transition-colors duration-200 text-center" data-id="element-82">
                  Get a Quote
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}